import { cn } from '@/lib/utils/cn';
import { QARI_STATUS_LABELS, type QariStatus } from '@/types/qari';

const TONE: Record<QariStatus, string> = {
  draft:
    'bg-ink-100 text-ink-700 dark:bg-ink-800 dark:text-ink-200',
  pending_review:
    'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200',
  under_verification:
    'bg-sky-100 text-sky-800 dark:bg-sky-900/40 dark:text-sky-200',
  approved:
    'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-200',
  rejected:
    'bg-rose-100 text-rose-800 dark:bg-rose-900/40 dark:text-rose-200',
  suspended:
    'bg-orange-100 text-orange-800 dark:bg-orange-900/40 dark:text-orange-200',
  inactive:
    'bg-ink-100 text-ink-600 dark:bg-ink-900 dark:text-ink-400',
};

export function QariStatusBadge({
  status,
  className,
}: {
  status: QariStatus;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5',
        'text-xs font-medium tracking-tight',
        TONE[status],
        className,
      )}
    >
      <span
        aria-hidden="true"
        className="inline-block h-1.5 w-1.5 rounded-full bg-current opacity-70"
      />
      {QARI_STATUS_LABELS[status]}
    </span>
  );
}
